// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"1ef94ec8","193":"aa6d1c15","413":"62f838a8","471":"19679416","496":"a59e5ddf","506":"ad48da47","534":"18b3346d","557":"e3ba1325","811":"c5c66799","878":"e5b0b526","885":"09ed2374","958":"bb5d54cf"}[chunkId] + ".chunk.js";
};